import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { LoggingService } from '../shared/services/logging/logging.service';
import * as fromExpense from '../expenses';

const log = new LoggingService();
export const ViewExpenseReceiptRoute: Ng2StateDeclaration = {
    name: 'receipt',
    url: '/receipt/:receiptId',
    data: { requiresAuth: true },
    params: { receipt: 0 },
    resolve: [
        {
            token: 'receiptId',
            deps: [Transition],
            resolveFn: resolveReceiptId
        },
        {
            token: 'expenseNumber',
            deps: [Transition],
            resolveFn: resolveExpenseNumber
        }
    ],
    component: fromExpense.ExpenseReceiptViewFeatureComponent
};

export function resolveReceiptId(t: Transition) {
    const receiptId = t.params().receiptId;
    log.debug({
        type: 'ViewExpenseReceiptRoute:receipt:resolve',
        t,
        receiptId
    });
    return receiptId;
}

export function resolveExpenseNumber(t: Transition) {
    const expenseNumber = t.params().ExpenseReportNumber;
    log.debug({
        type: 'ViewExpenseReceiptRoute:receipt:resolve',
        t,
        expenseNumber
    });
    return expenseNumber;
}
